module.exports = __webpack_public_path__ + "img/23.b1d82b97.png";